import { UtilImageS } from '../../../../Util/Image/S/Function/module/UtilImageS.js';
import { isOdd, toFixed3 } from '../../../../MShop/App/Store/Product/S/Function/process.js';
/*
 * 기본 jpeg 로 변경해주는 함수
 * bg 는 람다안에서 jpeg 면 기본으로 #ffffff
 * */

export const getBase64OrResize = ({ url = '', ...opt }) =>
  url.indexOf('data:image') > -1
    ? url
    : UtilImageS.getResizedUrl({
        url,
        ...opt,
      });

export const setOnDemandJpegUrl = (opt) =>
  getBase64OrResize({
    bg: 'ffffff',
    ...opt,
    format: 'jpeg',
  });

export const calculateThumbnailImage = ({ thumbnail, thumbnail_ratio, base_product_color_face_url }, opt) => {
  if (thumbnail.composite_template_id) thumbnail_ratio = 1;

  const ratio_size = Number.parseFloat(thumbnail_ratio) * 100 || 84;
  const is_100 = ratio_size == 100;
  const width = is_100
    ? opt.width
    : (() => {
        const val = Math.round((opt.width * ratio_size) / 100);
        return val + (isOdd(opt.width) == isOdd(val) ? 0 : 1);
      })();
  const max_size = (is_100 ? ratio_size : toFixed3(width / opt.width)) || 100;

  const url = thumbnail.url || base_product_color_face_url;
  const thumbnail_style = `
    max-width:${max_size}%;
    max-height:${max_size}%;
    ${url?.indexOf('data:image') > -1 ? `width:${width}px;` : ''}
  `.replace(/\s/g, '');
  const padding_size = (opt.width - width) / 2 || void 0;
  const bg = opt.bg || 'f6f6f6';
  const quality = opt.quality || 92;

  const url_data = {
    url,
    width: width || void 0,
    padding_size,
    quality,
    bg,
  };

  if (
    /* @@thumbnail is_pb 체크@@ */
    thumbnail.is_pb &&
    thumbnail.width !== thumbnail.height &&
    // thumbnail을 만들면서 이미지가 정사각형이어도 1px정도가 틀어지는 예외 케이스가 발생했습니다.
    Math.abs(thumbnail.width - thumbnail.height) > 1
  ) {
    url_data.r = 80;
  }

  return { is_100, url_data, thumbnail_style };
};
